import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// 글꼴 → 공통 토큰 → 공통 컴포넌트 → 이 앱의 CSS 순서다 — 순서가 뜻을 가진다. 토큰이 먼저 서야
// 컴포넌트 CSS 가 var(--*) 를 찾고, 이 앱의 CSS 가 뒤에 와야 공통 위에 얹힌다.
// 토큰·컴포넌트의 원본은 공통 리포 서브모듈의 `react/design-tokens/v3` 하나다(link: 로 문다 —
// 사본을 두지 않는다). 본문 Pretendard 는 이 앱이 든 서브셋(public/fonts), 고정폭 Sarasa Mono K 는
// 공통 v3 의 vendor 글꼴이다.
import "./fonts/fonts.css";
import "@mops/design-tokens-v3/vendor/fonts-sarasa.css";
import "@mops/design-tokens-v3/tokens.css";
import "@mops/design-tokens-v3/components.css";
// 차트 판의 구조 규칙(토큰으로 옮긴 것) — 토큰 뒤에 온다. uPlot.min.css 는 부르지 않는다(색 리터럴 · 시스템 글꼴).
import "@mops/charts-v2/charts.css";
import "./app.css";
import { App } from "./App";
import { registerServiceWorker } from "@mops/pwa-v1";
import { applyStoredTheme } from "./lib/theme";

applyStoredTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// 서비스 워커 등록은 공통 @mops/pwa-v1 이다(docs/decisions/pwa.md). 배포 빌드에서만 — 개발 서버에는
// sw.js 가 없고(빌드가 찍는다), 있었다면 HMR 모듈을 캐시해 화면이 안 바뀐다. http 는 공통이 조용히 건너뛴다.
registerServiceWorker({ enabled: import.meta.env.PROD });
